.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.headerRow {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--space-3);
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--ink-muted);
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.clear {
	background: none;
	border: none;
	color: var(--accent-rose);
	font: inherit;
	font-size: 0.85rem;
	cursor: pointer;
	padding: 0;
}

.clear:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.pills {
	display: flex;
	flex-wrap: wrap;
	gap: var(--space-2);
}

.pill {
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 6px var(--space-3);
	border-radius: 999px;
	background: var(--surface-input);
	color: var(--ink);
	border: 1px solid color-mix(in srgb, var(--ink) 10%, transparent);
	font: inherit;
	font-size: 0.85rem;
	cursor: pointer;
	transition:
		background 0.1s ease,
		border-color 0.1s ease;
}

.pill:hover:not(.pillActive) {
	border-color: color-mix(in srgb, var(--ink) 22%, transparent);
}

.pillActive {
	background: color-mix(in srgb, var(--accent-sage) 22%, transparent);
	border-color: var(--accent-sage);
	font-weight: 600;
}

.actions {
	display: flex;
	justify-content: flex-end;
}

.done {
	padding: var(--space-2) var(--space-4);
	background: var(--accent-sage);
	border: none;
	border-radius: var(--radius-md);
	color: #fff;
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}
